export enum JobType {
  SITE_LEAD,
  AREA_LEAD,
  STAND_LEAD,
  STAFF,
  NOT_ALLOCATED,
  NOT_REGISTERED
}
